import AuthService from "../services/auth.service";

function readStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const user = readStoredUser();
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

initialState["userVerifyData"] = null;

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    //Layer
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    //Layer
    logout({ commit }) {
      //AuthService.logout();
      commit("logout");
    },

    //layer
    storeUserVerifyData({ commit }, user) {
      commit("setUserVerifyData", user);
    },
  },
  mutations: {

    //Layer
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },

    //Layer
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },

    //Layer
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("jwt_token");
    },

    //Layer
    setUserVerifyData(state, user) {
      localStorage.setItem("userVerifyData", JSON.stringify(user));
      state.userVerifyData = user;
    },
  },
};